import { AuthService, User } from '@skinsoft/auth';
import { race } from 'rxjs';
import { bufferTime, first, map, mapTo, skipWhile } from 'rxjs/operators';
import Router from 'vue-router';

import { MovementDataStore, TaskDataStore } from '@skinsoft/entity';
import {
    MovementFeaturedList,
    MovementHistory,
    TaskFeaturedList,
    TaskHistory,
} from '@skinsoft/entity-ui';

import { Login } from './auth/page/login';
import { Dashboard } from './dashboard';
import { ActionMenuMovement } from './entity/component/action-menu/movement';
import { ActionMenuTask } from './entity/component/action-menu/task';
import { EntityList } from './entity/page/entity-list';
import { MovementPage } from './entity/page/movement';
import { TaskPage } from './entity/page/task';

export enum Routes {
    DASHBOARD = 'dashboard',
    LOGIN = 'login',
    MOVEMENT = 'movement',
    MOVEMENTS = 'movements',
    TASK = 'task',
    TASKS = 'tasks',
}

export const router = new Router({
    mode: 'history',
    routes: [
        {
            component: Dashboard,
            name: Routes.DASHBOARD,
            path: '/',
        },
        {
            component: Login,
            name: Routes.LOGIN,
            path: '/login',
        },
        {
            component: EntityList,
            name: Routes.TASKS,
            path: '/tasks',
            props: {
                entityDataStore: TaskDataStore.getInstance(),
                entityFeaturedList: TaskFeaturedList,
                entityHistory: TaskHistory,
                targetRouteName: Routes.TASK,
            },
        },
        {
            components: {
                actionMenu: ActionMenuMovement,
                default: EntityList,
            },
            name: Routes.MOVEMENTS,
            path: '/movements',
            props: {
                actionMenu: {
                    entityDataStore: MovementDataStore.getInstance(),
                },
                default: {
                    entityDataStore: MovementDataStore.getInstance(),
                    entityFeaturedList: MovementFeaturedList,
                    entityHistory: MovementHistory,
                    targetRouteName: Routes.MOVEMENT,
                },
            },
        },
        {
            components: {
                actionMenu: ActionMenuMovement,
                default: MovementPage,
            },
            name: Routes.MOVEMENT,
            path: '/movements/:id',
            props: {
                actionMenu: {
                    entityDataStore: MovementDataStore.getInstance(),
                },
            },
        },
        {
            components: {
                actionMenu: ActionMenuTask,
                default: TaskPage,
            },
            name: Routes.TASK,
            path: '/tasks/:id',
            props: {
                actionMenu: {
                    entityDataStore: TaskDataStore.getInstance(),
                },
            },
        },
        { path: '*', redirect: '/' },
    ],
});

router.beforeEach((to, __, next) => {
    AuthService.getInstance()
        .waitForUser$()
        .pipe(
            first(),
            map(authenticated => {
                if (!authenticated && to.name !== Routes.LOGIN) {
                    return { name: Routes.LOGIN };
                }

                if (authenticated && to.name === Routes.LOGIN) {
                    return false;
                }

                return;
            }),
        )
        .subscribe(next);
});
